/* Fliq Vintage drafts (fliq-listing): winkelwagenlogica voor de secties fliq-vc-dc en fliq-vc-dd.
   - add(): camera('s) + cadeaus in één /cart/add.js-call, daarna de Upcart-drawer openen.
   - Cadeauregels dragen property _fliq_gift; hun aantal volgt het aantal camera's van het product
     (camera weg = cadeaus weg). Prijs €0 komt van een automatische korting in Shopify, niet van deze code. */
window.FliqVC = window.FliqVC || (function () {
  var watched = {};   // productId -> [gift variant ids]

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }

  function openCart() {
    try { if (window.upcartRefreshCart) window.upcartRefreshCart(); } catch (e) {}
    if (window.upcartOpenCart) setTimeout(function () { try { window.upcartOpenCart(); } catch (e) {} }, 150);
    else window.location.href = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'cart';
  }

  function add(items, errEl) {
    if (errEl) errEl.hidden = true;
    return post('/cart/add.js', { items: items }).then(function (d) { openCart(); return d; }).catch(function (e) {
      if (errEl) { errEl.textContent = (e && (e.description || e.message)) || errEl.dataset.msg || 'Something went wrong. Please try again.'; errEl.hidden = false; }
      throw e;
    });
  }

  var busy = false;
  function syncGifts() {
    if (busy) return;
    busy = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var changes = [];
      Object.keys(watched).forEach(function (pid) {
        var n = 0;
        cart.items.forEach(function (i) { if (String(i.product_id) === pid) n += i.quantity; });
        cart.items.forEach(function (i) {
          if (i.properties && i.properties._fliq_gift === pid && i.quantity !== n) changes.push({ id: i.key, quantity: n });
        });
      });
      return changes.reduce(function (p, c) { return p.then(function () { return post('/cart/change.js', c); }); }, Promise.resolve())
        .then(function () { if (changes.length) { try { window.upcartRefreshCart && window.upcartRefreshCart(); } catch (e) {} } });
    }).catch(function () {}).then(function () { busy = false; });
  }

  var hooked = false;
  function watch(productId) {
    watched[String(productId)] = true;
    if (hooked) return;
    hooked = true;
    var t;
    var later = function () { clearTimeout(t); t = setTimeout(syncGifts, 400); };
    ['upcartSubscribeCartUpdated', 'upcartSubscribeItemRemoved'].forEach(function (fn) {
      try { if (typeof window[fn] === 'function') window[fn](later); } catch (e) {}
    });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) later(); });
  }

  // Kleurfoto in de galerij tonen
  function showMedia(gallery, index) {
    if (!gallery || index < 0) return;
    var x = gallery.clientWidth * index;
    gallery.scrollTo({ left: x, behavior: 'smooth' });
    // vangnet: smooth scroll wordt soms onderbroken (snap, verborgen tab) → dan direct springen
    setTimeout(function () { if (Math.abs(gallery.scrollLeft - x) > 2) gallery.scrollLeft = x; }, 500);
  }

  return { add: add, watch: watch, syncGifts: syncGifts, showMedia: showMedia };
})();
